'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.yearAgo;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/yearAgo.js
// module id = 758
// module chunks = 0